package ui.widget

import androidx.compose.animation.animateColorAsState
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import compose.assets.Svg
import compose.assets.svg.Check
import org.jetbrains.compose.resources.StringResource
import tools.rememberString


@Composable
fun InlineTabRow(
    selectedTabIndex: Int,
    tabsCount: Int,
    itemMaxWidth: Dp,
    tabBody: @Composable (index: Int) -> Unit
) {
    Box(Modifier.fillMaxWidth()) {
        Column(Modifier.fillMaxWidth()) {
            ScrollableTabRow(
                selectedTabIndex = selectedTabIndex,
                modifier = Modifier.width(itemMaxWidth * tabsCount).align(Alignment.CenterHorizontally),
                indicator = {},
                divider = {},
            ) {
                repeat(tabsCount) {
                    tabBody(it)
                }
            }
            HorizontalDivider()
        }
    }
}

@Composable
fun InlineTab(
    index: Int,
    selectedTabIndex: Int,
    label: StringResource,
    isClickable: (selectedTabIndex: Int, index: Int) -> Boolean = { selectedTabIndex, index -> selectedTabIndex > index },
    onClick: () -> Unit
) {
    val color by animateColorAsState(
        if (selectedTabIndex < index) MaterialTheme.colorScheme.onSurfaceVariant
        else MaterialTheme.colorScheme.primary
    )
    Row(
        modifier = Modifier
            .padding(vertical = 8.dp)
            .clip(CardDefaults.shape)
            .clickable(isClickable(selectedTabIndex, index)) {
                onClick()
            }
            .padding(8.dp)

    ) {
        Box(Modifier.align(Alignment.CenterVertically)) {
            if (index != 0) {
                Spacer(
                    Modifier
                        .padding(end = 24.dp)
                        .align(Alignment.Center).width(64.dp)
                        .height(4.dp)
                        .background(color, RoundedCornerShape(2.dp))
                )
            }
            Box(
                Modifier
                    .align(Alignment.CenterEnd)
                    .size(32.dp)
                    .background(color, shape = CircleShape)
            ) {
                if (selectedTabIndex > index) {
                    Icon(
                        imageVector = Svg.Check,
                        contentDescription = null,
                        tint = Color.Black,
                        modifier = Modifier.align(Alignment.Center)
                    )
                } else {
                    Text(
                        text = (index + 1).toString(),
                        modifier = Modifier.align(Alignment.Center),
                        textAlign = TextAlign.Center,
                        fontWeight = FontWeight.ExtraBold,
                        style = MaterialTheme.typography.titleLarge,
                        color = MaterialTheme.colorScheme.onPrimary
                    )
                }
            }
        }

        Space(8.dp)
        Text(
            text = label.rememberString(),
            modifier = Modifier.align(Alignment.CenterVertically),
            color = color
        )
    }
}